import axios from 'axios'

const state = () => ({
  sentiments: [],
  sentiment: {
    id: 0,
    subscription_id: null,
    title: '',
    blocked: 0,
  },
})

const getters = {
  getSentiments: (state) => state.sentiments,
  getSentiment: (state) => state.sentiment,
}

const actions = {
  async getSentiments({ rootState, commit }) {
    const response = await axios.get(rootState.api + '/sentiments/all', {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })

    commit('setSentiments', response.data)
  },
  async getSentiment({ rootState, commit }, { id }) {
    const response = await axios.get(
      rootState.api + '/sentiments/admin/' + id,
      {
        headers: {
          Authorization: 'Bearer ' + rootState.apiToken,
        },
      },
    )

    commit('setSentiment', response.data)
  },
  async updateSentiment({ rootState, state }) {
    await axios.put(rootState.api + '/sentiments/admin', state.sentiment, {
      headers: {
        Authorization: 'Bearer ' + rootState.apiToken,
      },
    })
  },
  async blockSentiment({ rootState, state }) {
    await axios.put(
      rootState.api + '/sentiments/block',
      { id: state.sentiment.id, blocked: 1 },
      {
        headers: {
          Authorization: 'Bearer ' + rootState.apiToken,
        },
      },
    )
  },
  async unblockSentiment({ rootState, state }) {
    await axios.put(
      rootState.api + '/sentiments/block',
      { id: state.sentiment.id, blocked: 0 },
      {
        headers: {
          Authorization: 'Bearer ' + rootState.apiToken,
        },
      },
    )
  },
}

const mutations = {
  setSentiments(state, payload) {
    state.sentiments = payload
  },
  setSentiment(state, payload) {
    state.sentiment = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
